export default function Footer() {
  return (
    <footer className="text-center py-9 border-t border-mm-border">
      <div className="text-sm text-mm-parchment/50 mb-1">🐻 House Selwyn</div>
      <div className="text-xs text-mm-parchment/50 italic tracking-wide opacity-70">
        Gu sìorraidh is gu bràth
      </div>
    </footer>
  )
}
